import { ResponsiveCommandSelect, SelectOption } from "../responsive-select";
import { TicketPriority } from "@/lib/types/database";

interface PrioritySelectProps {
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  required?: boolean;
  highZIndex?: boolean;
}

const PRIORITY_OPTIONS: SelectOption[] = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "critical", label: "Critical" },
  { value: "urgent", label: "Urgent" },
];

export function PrioritySelect({
  value,
  onValueChange,
  placeholder = "Select priority...",
  disabled = false,
  error = false,
  required = false,
  highZIndex = false,
}: PrioritySelectProps) {
  return (
    <ResponsiveCommandSelect
      value={value}
      onValueChange={onValueChange}
      options={PRIORITY_OPTIONS.map((o) => ({ ...o, searchableText: o.label }))}
      placeholder={placeholder}
      disabled={disabled}
      className={highZIndex ? "z-[100]" : undefined}
    />
  );
}
